export const enum FormPropertyShareStatechartEvent {
  /**
   * User wants to submit form
   */
  wantToSubmitForm = 'wantToSubmitForm',

  /**
   * Google captcha value changed
   */
  captchaValueChanged = 'captchaValueChanged',

  /**
   * Input data is valid
   */
  inputIsValid = 'inputIsValid',

  /**
   * Input data is invalid
   */
  inputIsInvalid = 'inputIsInvalid',

  /**
   * Submit request is successful
   */
  submitSuccessful = 'submitSuccessful',

  /**
   * Submit request failed
   */
  submitFailed = 'submitFailed',
}
